import useAuth from '../auth/useAuth';

// The backend stores exactly one role per user (onboarding.User.RoleType), but
// callers were written against Auth0's roles array, so keep the list shape.
export default function useRoles() {
  const { user, isLoading } = useAuth();
  return { roles: user?.role ? [user.role] : [], isLoading };
}
